import { useEffect } from 'react'

/**
 * Custom hook to handle data-background attributes
 * Replicates the jQuery functionality from the original template
 */
export const useDataBackground = () => {
  useEffect(() => {
    const applyBackgrounds = () => {
      const elements = document.querySelectorAll('[data-background]')
      elements.forEach((element) => {
        const bg = element.getAttribute('data-background')
        if (bg) {
          ;(element as HTMLElement).style.backgroundImage = `url(${bg})`
        }
      })
    }

    // Apply on mount
    applyBackgrounds()

    // Re-apply after a short delay to catch dynamically loaded content
    const timeoutId = setTimeout(applyBackgrounds, 100)

    // Set up a MutationObserver to handle dynamically added elements
    const observer = new MutationObserver(() => {
      applyBackgrounds()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    return () => {
      clearTimeout(timeoutId)
      observer.disconnect()
    }
  }, [])
}

export default useDataBackground


